module.exports = __webpack_public_path__ + "img/google.37f5b881.svg";